import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Context } from '../../store/Store'
import { BsArrowLeft, BsCloudUpload, BsHddStack } from 'react-icons/bs'
import axios from 'axios'

export function PoDrafts() {
  const { app } = React.useContext(Context)
  const [drafts, setDrafts] = useState([])
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    const fetchDrafts = async () => {
      setLoading(true)
      try {
        // Récupérer les brouillons uniquement depuis le serveur
        const response = await axios.get(
          `${process.env.REACT_APP_APOLLO_URL || 'https://extranet.biobreizh.org'}/wp-json/bb/v1/po/drafts/user/${app.profil.id}`
        )

        if (response.status === 200) {
          const serverDrafts = response.data.map(draft => ({
            id: draft.draft_id,
            serverDraftId: draft.draft_id,
            currentStep: draft.current_step,
            savedAt: draft.updated_at,
            formType: draft.form_type
          }))

          // Trier par date de modification (du plus récent au plus ancien)
          serverDrafts.sort((a, b) => new Date(b.savedAt) - new Date(a.savedAt))

          setDrafts(serverDrafts)
        } else {
          setDrafts([])
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des brouillons:', error)
        setDrafts([])
      } finally {
        setLoading(false)
      }
    }

    fetchDrafts()
  }, [app.profil.id])

  const handleDeleteDraft = async (draft, e) => {
    e.stopPropagation()
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce brouillon ?')) {
      try {
        // Supprimer du serveur
        await axios.delete(
          `${process.env.REACT_APP_APOLLO_URL || 'https://extranet.biobreizh.org'}/wp-json/bb/v1/po/draft/${draft.id}`
        )

        // Mettre à jour la liste des brouillons
        setDrafts(drafts.filter(d => d.id !== draft.id))
      } catch (error) {
        console.error('Erreur lors de la suppression du brouillon:', error)
        alert('Une erreur est survenue lors de la suppression du brouillon.')
      }
    }
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <Link to="/po" className="inline-flex items-center text-base font-medium text-gray-600 hover:text-gray-900">
          <BsArrowLeft className="mr-2" /> Retour
        </Link>
        <h1 className="text-2xl font-bold text-gray-900 mt-4">Demandes d'aides en cours</h1>
        <p className="mt-2 text-gray-600">
          Retrouvez ici toutes vos demandes d'aides commencées mais non finalisées.
        </p>
      </div>

      {loading ? (
        <div className="bg-white shadow overflow-hidden rounded-md p-6 text-center">
          <p className="text-gray-500">Chargement des demandes en cours...</p>
        </div>
      ) : drafts.length === 0 ? (
        <div className="bg-white shadow overflow-hidden rounded-md p-6 text-center">
          <p className="text-gray-500">Vous n'avez aucune demande en cours.</p>
          <Link
            to="/po"
            className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-base hover:bg-base-dark"
          >
            Créer une nouvelle demande
          </Link>
        </div>
      ) : (
        <div className="bg-white shadow overflow-hidden sm:rounded-md">
          <ul className="divide-y divide-gray-200">
            {drafts.map((draft) => (
              <li key={draft.id}>
                <div
                  className="px-4 py-4 sm:px-6 hover:bg-gray-50 cursor-pointer"
                  onClick={() => {
                    // Accéder directement au formulaire avec les paramètres du brouillon via query string
                    navigate(`/po/po-form/${draft.formType.title}/${draft.formType.mesure}?aidetype=${encodeURIComponent(draft.formType.aidetype)}&draftId=${draft.serverDraftId}`);
                  }}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center">
                        <p className="text-sm font-medium text-base truncate">
                          {draft.formType.title} - {draft.formType.mesure}
                        </p>
                        <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-base-light/20 text-base">
                          <BsCloudUpload className="mr-1" /> Sauvegardé
                        </span>
                      </div>
                      <p className="mt-1 flex items-center text-sm text-gray-500">
                        <span className="truncate">Type: {draft.formType.aidetype}</span>
                      </p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex items-center">
                      <p className="text-sm text-gray-500 mr-4">
                        Dernière modification: {new Date(draft.savedAt).toLocaleString()}
                      </p>
                      <button
                        onClick={(e) => handleDeleteDraft(draft, e)}
                        className="ml-2 inline-flex items-center px-2.5 py-1.5 border border-gray-300 text-xs font-medium rounded text-red-700 bg-white hover:bg-gray-50"
                      >
                        Supprimer
                      </button>
                    </div>
                  </div>
                  <div className="mt-2">
                    <div className="relative">
                      <div className="overflow-hidden h-3 text-xs flex rounded bg-gray-200">
                        <div
                          style={{ width: `${(draft.currentStep / 3) * 100}%` }}
                          className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-base"
                        ></div>
                      </div>
                      <div className="text-xs text-gray-500 mt-1">
                        Étape {draft.currentStep} sur 3
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
